import { render, staticRenderFns } from "./AddGarment.vue?vue&type=template&id=41e62336&scoped=true&"
import script from "./AddGarment.vue?vue&type=script&lang=js&"
export * from "./AddGarment.vue?vue&type=script&lang=js&"
import style0 from "./AddGarment.vue?vue&type=style&index=0&id=41e62336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e62336",
  null
  
)

export default component.exports